/**
 * Utility functions for API parameter validation and building
 */

/**
 * Validates optional parameters for consumer reviews API
 * @param {object} params - Parameters to validate
 * @returns {object} Validation result with isValid flag and error message
 */
export const validateConsumerReviewParams = (params) => {
  const { sort, filter, perPage, page } = params;

  // Validate sort parameter
  if (sort != null && (Number.isNaN(sort) || sort < 0 || sort > 8)) {
    return {
      isValid: false,
      error:
        `Invalid sort parameter. Sort Options: 0 - Sort by helpfulness (desc), then by total feedback count (desc), then by submission time (desc);
        1 - Sort by submission time (desc); 2 - Sort by submission time (asc); 3 - Sort by rating (desc), then by submission time (desc);
        4 - Sort by rating (asc), then by submission time (desc)l 5 - Sort by review text length (desc); 6 - Sort by review text length (asc);
        7 - Sort by total positive feedback count (desc), then by rating (desc);
        8 - Sort by total positive feedback count (desc), then by rating (asc)`,
    };
  }

  // Validate filter parameter
  if (filter != null && (Number.isNaN(filter) || filter < 0 || filter > 6)) {
    return {
      isValid: false,
      error: `Invalid filter parameter. Must be 0-6 
        (Filter Options: 0 - Rating equals 1, 1 - Rating equals 2, 2 - Rating equals 3,
        3- Rating equals 4, 4 - Rating equals 5, 5 - Rating is greater than 3, 6 - Rating is less thank 4)`,
    };
  }

  // Validate perPage parameter
  if (perPage != null && (Number.isNaN(perPage) || perPage < 1)) {
    return {
      isValid: false,
      error: 'Invalid perPage parameter. Must be greater than 0',
    };
  }

  // Validate page parameter
  if (page != null && (Number.isNaN(page) || page < 1)) {
    return {
      isValid: false,
      error: 'Invalid page parameter. Must be >= 1',
    };
  }

  return { isValid: true };
};

/**
 * Builds query parameters object for consumer reviews API
 * Only includes defined values to avoid 'undefined' strings
 * @param {object} params - Parameters to build into query object
 * @returns {object} Query parameters object
 */
export const buildConsumerReviewQueryParams = (params) => {
  const { make, model, year, sort, page, perPage, filter } = params;

  // Build params object with required fields
  const queryParams = {
    make: String(make),
    model: String(model),
    year: String(year),
  };

  // Add optional parameters only if they are defined (not null, undefined, or empty string)
  if (sort != null) queryParams.sort = String(sort);
  if (page != null) queryParams.page = String(page);
  if (perPage != null) queryParams.perPage = String(perPage);
  if (filter != null) queryParams.filter = String(filter);

  return queryParams;
};